import * as THREE from "three";
import * as perlin from "./lib/perlin"
import sceneConfig from "./conf/config-prod.js"

let renderer

var scene = new THREE.Scene();
var camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.z = 5;

var ambientLight2 = new THREE.AmbientLight( 0xffffff, 1 );
scene.add( ambientLight2 );

const spotLight = new THREE.SpotLight( 0xffffff );
spotLight.position.set( 10, 10, 10 );
scene.add( spotLight );

sceneConfig.spheres.map(s => {
  s.sphere_geometry = new THREE.SphereGeometry(1.5, 128, 128);
  const texture = new THREE.TextureLoader().load(s.matcapTextureImg);
  texture.format = THREE.RGBAFormat

  if(s.matcapTextureImg.includes('trans')) { 
      s.material = new THREE.MeshStandardMaterial({ 
        map: texture,
        transparent: true,
          alphaTest: 0.5,
          side: THREE.FrontSide, 
      });

  } else {
    s.material = new THREE.MeshMatcapMaterial({
        matcap: texture,
        transparent: true,
          alphaTest: 0.1,
          specular: 0xcccccc,
          side: THREE.FrontSide, 
      });
  }
  s.sphere = new THREE.Mesh(s.sphere_geometry, s.material);
  s.sphere.geometry.attributes.position.needsUpdate = true;
  scene.add(s.sphere)
})



var update = function ({sphere, speed, k, mul}) {
  var time = performance.now() * speed;
  var p = new THREE.Vector3();   
  const positions = sphere.geometry.attributes.position;

  for (var i = 0; i < positions.count; i++) {
    p.fromBufferAttribute(positions, i)
    p.normalize().multiplyScalar(
      1 + mul * noise.perlin3(p.x * k + time, p.y * k, p.z * k)
    )
    positions.setXYZ(i, p.x, p.y, p.z);
  }

  positions.needsUpdate = true;
  sphere.geometry.computeVertexNormals(); 
};


function animate() {
  sceneConfig.spheres.map(s => update({
    k: s.perlin.k,
    mul: s.perlin.mul,
    speed: s.perlin.speed,
    sphere: s.sphere,
  }))
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
}

const resize = () => {
  renderer.setSize(window.innerWidth, window.innerHeight)
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
};

export const createScene = (el) => {
  renderer = new THREE.WebGLRenderer({ antialias: true, canvas: el});
  renderer.setClearColor(0xfafafa);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);
  resize();
  animate();
}

window.addEventListener('resize', resize);

export {
  animate,
  renderer,
}
